import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-parlor-green text-parlor-cream shadow-lg py-4' : 'bg-transparent text-parlor-cream py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
        <a href="#" className="font-serif text-2xl md:text-3xl font-bold tracking-wider flex items-center gap-2">
          <SafeIcon icon="Camera" className="text-parlor-gold" />
          MAGNET PARLOR
        </a>
        
        <div className="hidden md:flex items-center gap-8 text-sm uppercase tracking-widest font-medium">
          <a href="#experience" className="hover:text-parlor-gold transition-colors">Experience</a>
          <a href="#gallery" className="hover:text-parlor-gold transition-colors">Gallery</a>
          <a href="#shop" className="hover:text-parlor-gold transition-colors">Shop</a>
          <a href="#contact" className="px-6 py-2 border border-parlor-gold text-parlor-gold hover:bg-parlor-gold hover:text-parlor-green transition-all duration-300">
            Book Now
          </a>
        </div>

        <button className="md:hidden text-2xl">
          <SafeIcon icon="Menu" />
        </button>
      </div>
    </motion.nav>
  );
};

export default Navbar;